<template>
  <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Nhật ký thu hoạch</div>
          </div>
          <div class="col-xs-12 col-md q-pa-md">
            <q-select clearable emit-value v-model="farm" :options="farms" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, farm ,'name')" label="Nông trường">
              <template v-slot:prepend>
                <q-icon name="filter_vintage" />
              </template>
            </q-select>
          </div>
          <div class="col-xs-12 col-md q-pa-md">
            <q-select clearable emit-value v-model="lot" :options="lotOptions" option-value="id" option-label="name" label="Lô" :readonly="farm ? farm.listLot ? false : false : true">
              <template v-slot:prepend>
                <q-icon name="local_florist" />
              </template>
            </q-select>
          </div>
        </q-card>
        <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
        <q-table
          :data="reportsData"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :hide-bottom="!_.isEmpty(reportsData)"
          :key="tableKey"
          :loading="load"
          :pagination.sync= pagination
          >
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="!props.row.deleted">
              <q-td @click.native="routeReportData(props.row._id)" class="label-xs-right text-center">{{ props.row.__index+1 }}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.date" class="label-xs-right text-center">{{props.row.date instanceof firebase().firestore.Timestamp === true ? moment((props.row.date).toDate()).format(defaultDateFormat): props.row.date }}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.farm" class="label-xs-right text-center">{{ $getNameById(farmStore.list, props.row.farm ,'name')}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.lot" class="label-xs-right text-center">{{ props.row.lot}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.job" class="label-xs-right text-center">{{ $getNameById(jobStore.list, props.row.job ,'name')}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.totalWeight" class="label-xs-right text-center">{{ props.row.totalWeight}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.unit" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.list, props.row.job ,'unit') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.type" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.type) ? $getNameById(workerTypes, props.row.worker.type,'label') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.number" class="label-xs-right text-center">{{ props.row.worker.number}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.meka" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.meka) ? $getNameById(mekaStore.list, props.row.worker.meka ,'displayName') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.supervisor" class="label-xs-right text-center">{{ props.row.supervisor }}</q-td>
              <q-td class="label-xs-right text-center" @click.native="clickDeleteButton(props)" >
                <q-btn ripple flat round color="black" icon="delete"/>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Float add button -->
        <q-page-sticky class="q-ma-md item-center" :style="'right:unset; left: '+ ($q.screen.width/2 - 45) + 'px'">
          <q-btn fab icon="add" color="green" @click="routeReportData(null,'CREATE')"/>
        </q-page-sticky>
    <!-- Delete Record -->
      <q-dialog v-model="deleteDialog" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="delete" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
/* eslint-disable no-unused-vars */
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
import view from 'src/modules/reports/components/index.vue'
export default {
  mixins: [view],
  data() {
    return {
      collection: "Harvest",
      headers: [{
        label: "No",
        align: "center",
        name: "no",
        },
        {
        label: "Ngày",
        align: "center",
        name: "date",
        field: 'date',
        sort: (a, b, rowA, rowB) => a.seconds - b.seconds,
        sortable: true,
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm",
        },
        {
        label: "Lô",
        align: "center",
        name: "lot",
        },
        {
        label: "Nội dung CV",
        align: "center",
        name: "job",
        },
        {
        label: "Khối lượng",
        align: "center",
        name: "totalWeight",
        },
        {
        label: "Đơn vị tính",
        align: "center",
        name: "unit",
        },
        {
        label: "Loại nhân công",
        align: "center",
        name: "type",
        },
        {
        label: "Số lượng",
        align: "center",
        name: "number",
        },
        {
        label: "Meka",
        align: "center",
        name: "meka",
        },
        {
        label: "Giám sát",
        align: "center",
        name: "supervisor",
        }],
    }
  },
  methods: {
    async deleteItem() {
      let vm = this
      vm.deleteDialog = false
      vm.tableKey ++
      vm.$refs.bar.start()
      let dataSubmit = vm._.cloneDeep(vm.reports[vm.selectedRowIndex])
      dataSubmit.deleted = true
      let submitModel = { id: vm.reports[vm.selectedRowIndex]._id, data: dataSubmit}
      await vm.$command.execute('updateHarvest', submitModel).then(async () => {
        vm.$q.notify({
          message: 'Đã lưu thành công',
          color: 'black',
          icon: 'check'
        })
        await this.fetchData()
      },  { mode: 'no-cors'} ).catch((error) => {
        vm.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      })
      vm.$refs.bar ? vm.$refs.bar.stop() : null
    },
    routeReportData(reportId, mode) {
      this.$router.push({
        name: '/harvest/entry',
        query: {
          id: reportId ? reportId : undefined,
        },
        params: {
          reportId: reportId,
          mode: mode ? mode : undefined
        }
      });
    },
  }
}
</script>
